// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";
import * as API_Account from "../API.Account/index.js";
import * as API_Document from "../API.Document/index.js";
import * as App_Route from "../App.Route/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as $$Error from "../Error/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Steps_Step3_Types from "../Steps.Step3.Types/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
import * as Steps_WorkQueue_State from "../Steps.WorkQueue.State/index.js";
import * as Widgets_Attachments from "../Widgets.Attachments/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Comments from "../Widgets.Comments/index.js";
import * as Widgets_Form from "../Widgets.Form/index.js";
import * as Widgets_Form_Class from "../Widgets.Form.Class/index.js";
import * as Widgets_FormPreview from "../Widgets.FormPreview/index.js";
import * as Widgets_Signature from "../Widgets.Signature/index.js";
import * as Widgets_Signature_Group from "../Widgets.Signature.Group/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff));
var except = /* #__PURE__ */ Control_Monad_Except_Trans.except(Effect_Aff.applicativeAff);
var runGraphQL_ = /* #__PURE__ */ GraphQL_Join.runGraphQL_(GraphQL_Query.qgql);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var eqRNTY = /* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString);
var notEq = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ Data_Maybe.eqMaybe(eqRNTY));
var notEq1 = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var notEq2 = /* #__PURE__ */ Data_Eq.notEq(Data_Argonaut_Core.eqJson);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var eq = /* #__PURE__ */ Data_Eq.eq(eqRNTY);
var notEq3 = /* #__PURE__ */ Data_Eq.notEq(API_Account.eqAccType);
var map2 = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Effect_Aff.functorAff));
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var syncDocMetadata = function (doc) {
    return function (workQueueState) {
        return function (workQueueUi) {
            var teacherOption = function (teacher) {
                return {
                    label: teacher.name,
                    value: teacher
                };
            };
            var semesterOption = function (semester) {
                return {
                    label: semester.name,
                    value: semester
                };
            };
            return {
                state: Steps_WorkQueue_State.setTeacherAndSemester(workQueueState)(doc.teacher)(doc.semester),
                ui: {
                    expandedStudents: workQueueUi.expandedStudents,
                    search: workQueueUi.search,
                    teacher: Widgets_BetterSelect.setSelected(workQueueUi.teacher)(map(teacherOption)(doc.teacher)),
                    semester: Widgets_BetterSelect.setSelected(workQueueUi.semester)(new Data_Maybe.Just(semesterOption(doc.semester)))
                }
            };
        };
    };
};
var saveDocument = function (v) {
    return Control_Monad_Except_Trans.runExceptT((function () {
        var json = Widgets_Form.formData(v.fillState.form);
        return bind(except(Steps_WorkQueue_State.getTeacherOrErr(v.workQueueState)))(function (teacher) {
            return bind(except(Steps_WorkQueue_State.getSemesterOrErr(v.workQueueState)))(function (semester) {
                return runGraphQL_(API_Document.updateDocument(v.fillState.doc)(json)({
                    teacher: teacher.id,
                    semester: semester.semester
                }));
            });
        });
    })());
};
var mergeTransitionWaitState = function (waitState) {
    return function (loadedState) {
        var workQueueUi = {
            search: loadedState.workQueueUi.search,
            semester: loadedState.workQueueUi.semester,
            teacher: loadedState.workQueueUi.teacher,
            expandedStudents: waitState.workQueueUi.expandedStudents
        };
        return {
            queue: loadedState.queue,
            position: loadedState.position,
            anchor: loadedState.anchor,
            activeSection: loadedState.activeSection,
            sectionIntent: loadedState.sectionIntent,
            workQueueState: loadedState.workQueueState,
            workQueueCache: loadedState.workQueueCache,
            fillState: loadedState.fillState,
            transitionState: waitState.transitionState,
            workQueueUi: workQueueUi
        };
    };
};
var initialQueuePosition = function (workQueueState) {
    return function (queue) {
        if (workQueueState.currentDoc instanceof Data_Maybe.Nothing) {
            return 0;
        };
        if (workQueueState.currentDoc instanceof Data_Maybe.Just) {
            return Data_Maybe.fromMaybe(0)(Data_Array.findIndex(Steps_Step3_Types.matchesLookup(workQueueState.currentDoc.value0))(queue));
        };
        throw new Error("Failed pattern match at Steps.Step3.FillQueue (line 122, column 45 - line 124, column 76): " + [ workQueueState.currentDoc.constructor.name ]);
    };
};
var initFormSigs = function (account) {
    return function (ft) {
        return function (doc) {
            var initSig = function (field) {
                return Widgets_Signature.loadDefaults(Widgets_Signature.AuthoritativeOp.value)(Widgets_Signature.fromDocSigField(doc.id)(field))(field);
            };
            return Widgets_Signature_Group.initSigGroup(account)("form-signatures")(doc.id)((function () {
                var $58 = Data_Array["null"](doc.signature_fields);
                if ($58) {
                    return map1(Widgets_Signature.fromFormSigField(doc.id))(ft.signatures);
                };
                return map1(initSig)(doc.signature_fields);
            })());
        };
    };
};
var loadFormFillLayout = function (state) {
    return function (fbasic) {
        return function (doc) {
            return bind(except(Data_Either.note(new $$Error.StringError("FormType " + (GraphQL_Type.innerId(fbasic.id) + " wasn't loaded")))(Steps_WorkQueue_Cache.getFormType(state.workQueueCache)(fbasic.id))))(function (ftype) {
                var form = (function () {
                    var v = Widgets_Form.fromFormType(ftype);
                    return {
                        fields: v.fields,
                        id: v.id,
                        label: v.label,
                        access: doc.access
                    };
                })();
                return pure({
                    form: form,
                    preview: Widgets_FormPreview.initDocPreview(doc),
                    signatures: Widgets_Signature_Group.loadSignatures(doc)(initFormSigs(state.workQueueCache.account)(ftype)(doc)),
                    comments: Widgets_Comments.initComments({
                        id: "form-comments",
                        formId: doc.id,
                        comments: doc.comments,
                        can: doc.can
                    }),
                    attachments: Widgets_Attachments.initAttachments({
                        id: "form-attachments",
                        formId: doc.id,
                        attachments: doc.attachments
                    }),
                    doc: doc
                });
            });
        };
    };
};
var hasUnsavedDocumentChanges = function (state) {
    var teacherUnsavedChanges = function (v) {
        return notEq(map(function (v1) {
            return v1.id;
        })(v.workQueueState.teacher))(map(function (v1) {
            return v1.id;
        })(v.fillState.doc.teacher));
    };
    var semesterUnsavedChanges = function (v) {
        return notEq1(map(function (v1) {
            return v1.semester;
        })(v.workQueueState.semester))(new Data_Maybe.Just(v.fillState.doc.semester.semester));
    };
    var teacherChanged = teacherUnsavedChanges(state);
    var semesterChanged = semesterUnsavedChanges(state);
    var nextJson = Widgets_Form.formData(state.fillState.form);
    var jsonChanged = notEq2(nextJson)(state.fillState.doc.json);
    var changed = jsonChanged || (teacherChanged || semesterChanged);
    return changed;
};
var shouldSaveDocument = function (state) {
    return Steps_Step3_Types.hasEditableFields(state.fillState) && hasUnsavedDocumentChanges(state);
};
var finaliseFillState = function (state) {
    return function (formCtx) {
        return function (doc) {
            return function (fillState) {
                var normaliseDocument = function (workQueueState) {
                    return function (sourceDoc) {
                        return function (form) {
                            var normalizedDoc = {
                                access: sourceDoc.access,
                                attachments: sourceDoc.attachments,
                                can: sourceDoc.can,
                                comments: sourceDoc.comments,
                                contact: sourceDoc.contact,
                                courses: sourceDoc.courses,
                                created_at: sourceDoc.created_at,
                                employer: sourceDoc.employer,
                                exports: sourceDoc.exports,
                                formId: sourceDoc.formId,
                                formName: sourceDoc.formName,
                                id: sourceDoc.id,
                                locked_at: sourceDoc.locked_at,
                                mutations: sourceDoc.mutations,
                                position: sourceDoc.position,
                                semester: sourceDoc.semester,
                                signature_fields: sourceDoc.signature_fields,
                                signatures: sourceDoc.signatures,
                                student: sourceDoc.student,
                                teacher: sourceDoc.teacher,
                                updated_at: sourceDoc.updated_at,
                                verifications: sourceDoc.verifications,
                                json: Widgets_Form.formData(form)
                            };
                            return new Data_Tuple.Tuple(Steps_WorkQueue_Cache.insertDocument(normalizedDoc)(workQueueState), normalizedDoc);
                        };
                    };
                };
                return bind1(Widgets_Form.setFormData(formCtx)(doc.json)(fillState.form))(function (form) {
                    var v = normaliseDocument(state.workQueueState)(doc)(form);
                    return pure1({
                        queue: state.queue,
                        position: state.position,
                        anchor: state.anchor,
                        activeSection: state.activeSection,
                        sectionIntent: state.sectionIntent,
                        transitionState: state.transitionState,
                        workQueueState: v.value0,
                        workQueueUi: state.workQueueUi,
                        workQueueCache: state.workQueueCache,
                        fillState: {
                            attachments: fillState.attachments,
                            comments: fillState.comments,
                            preview: fillState.preview,
                            signatures: fillState.signatures,
                            form: form,
                            doc: v.value1
                        }
                    });
                });
            };
        };
    };
};
var loadExistingFillState = function (state) {
    return function (v) {
        return function (workQueueState) {
            return function (maybeDoc) {
                var cachedDoc = Steps_WorkQueue_Cache.getDoc(workQueueState)(v.id);
                return bind((function () {
                    if (maybeDoc instanceof Data_Maybe.Just && eq(maybeDoc.value0.id)(v.id)) {
                        return pure(new Data_Tuple.Tuple(Steps_WorkQueue_Cache.insertDocument(maybeDoc.value0)(workQueueState), maybeDoc.value0));
                    };
                    if (cachedDoc instanceof Data_Maybe.Just) {
                        return pure(new Data_Tuple.Tuple(Steps_WorkQueue_Cache.insertDocument(cachedDoc.value0)(workQueueState), cachedDoc.value0));
                    };
                    if (cachedDoc instanceof Data_Maybe.Nothing) {
                        return Steps_WorkQueue_Cache.getDocument(workQueueState)(v.form_type)(v.id);
                    };
                    throw new Error("Failed pattern match at Steps.Step3.FillQueue (line 205, column 37 - line 208, column 58): " + [ maybeDoc.constructor.name, cachedDoc.constructor.name ]);
                })())(function (v1) {
                    var synced = syncDocMetadata(v1.value1)(v1.value0)(state.workQueueUi);
                    var nextBase = (function () {
                        var $79 = {};
                        for (var $80 in state) {
                            if ({}.hasOwnProperty.call(state, $80)) {
                                $79[$80] = state[$80];
                            };
                        };
                        $79.workQueueState = Steps_WorkQueue_State.setCurrentDoc(synced.state)(new Data_Maybe.Just({
                            formId: v.form_type.id,
                            studentId: v1.value1.student.id,
                            documentId: new Data_Maybe.Just(v1.value1.id)
                        }));
                        $79.workQueueUi = synced.ui;
                        return $79;
                    })();
                    return bind(loadFormFillLayout(nextBase)(v.form_type)(v1.value1))(function (fillState) {
                        var formCtx = Widgets_Form_Class.initFormContext(state.workQueueCache.account)(v1.value1);
                        return except(finaliseFillState(nextBase)(formCtx)(v1.value1)(fillState));
                    });
                });
            };
        };
    };
};
var loadPreviousFillState = function (state) {
    return function (doc) {
        return function (formId) {
            return function (workQueueState) {
                return bind(except(Data_Either.note(new $$Error.StringError("Unknown formtype " + GraphQL_Type.innerId(formId)))(Steps_WorkQueue_Cache.getForm(workQueueState)(formId))))(function (ftype) {
                    var synced = syncDocMetadata(doc)(workQueueState)(state.workQueueUi);
                    var nextBase = (function () {
                        var $86 = {};
                        for (var $87 in state) {
                            if ({}.hasOwnProperty.call(state, $87)) {
                                $86[$87] = state[$87];
                            };
                        };
                        $86.workQueueState = synced.state;
                        $86.workQueueUi = synced.ui;
                        return $86;
                    })();
                    return bind(loadFormFillLayout(nextBase)(ftype)(doc))(function (fillState) {
                        var formCtx = Widgets_Form_Class.initFormContext(state.workQueueCache.account)(doc);
                        var currentBase = (function () {
                            var $89 = {};
                            for (var $90 in nextBase) {
                                if ({}.hasOwnProperty.call(nextBase, $90)) {
                                    $89[$90] = nextBase[$90];
                                };
                            };
                            $89.workQueueState = Steps_WorkQueue_State.setCurrentDoc(nextBase.workQueueState)(new Data_Maybe.Just({
                                formId: formId,
                                studentId: doc.student.id,
                                documentId: new Data_Maybe.Just(doc.id)
                            }));
                            return $89;
                        })();
                        return except(finaliseFillState(currentBase)(formCtx)(doc)(fillState));
                    });
                });
            };
        };
    };
};
var createDocFormFillState = function (state) {
    return function (formId) {
        return function (student) {
            return bind(except(Data_Either.note(new $$Error.StringError("Unknown formtype " + GraphQL_Type.innerId(formId)))(Steps_WorkQueue_Cache.getForm(state.workQueueState)(formId))))(function (ftype) {
                return bind(except(Steps_WorkQueue_State.getSemesterOrErr(state.workQueueState)))(function (semester) {
                    return bind((function () {
                        var $92 = notEq3(state.workQueueCache.account.type)(API_Account.BoardAccount.value);
                        if ($92) {
                            return map2(Data_Maybe.Just.create)(except(Steps_WorkQueue_State.getTeacherOrErr(state.workQueueState)));
                        };
                        return pure(Data_Maybe.Nothing.value);
                    })())(function (teacher) {
                        return bind(Steps_WorkQueue_Cache.newDocument(state.workQueueState)(ftype)({
                            student_id: student,
                            semester: semester.semester,
                            teacher_id: map(function (v) {
                                return v.id;
                            })(teacher)
                        }))(function (v) {
                            var nextBase = (function () {
                                var $94 = {};
                                for (var $95 in state) {
                                    if ({}.hasOwnProperty.call(state, $95)) {
                                        $94[$95] = state[$95];
                                    };
                                };
                                $94.workQueueState = Steps_WorkQueue_State.setCurrentDoc(v.value0)(new Data_Maybe.Just({
                                    formId: formId,
                                    studentId: v.value1.student.id,
                                    documentId: new Data_Maybe.Just(v.value1.id)
                                }));
                                return $94;
                            })();
                            return bind(loadFormFillLayout(nextBase)(ftype)(v.value1))(function (fillState) {
                                var formCtx = (function () {
                                    var v1 = Widgets_Form_Class.initFormContext(state.workQueueCache.account)(v.value1);
                                    return {
                                        access: v1.access,
                                        account: v1.account,
                                        autofillArgs: v1.autofillArgs,
                                        curIndex: v1.curIndex,
                                        doc: v1.doc,
                                        parentIds: v1.parentIds,
                                        isAutofilling: true
                                    };
                                })();
                                return except(finaliseFillState(nextBase)(formCtx)(v.value1)(fillState));
                            });
                        });
                    });
                });
            });
        };
    };
};
var loadFillState = function (state) {
    return function (doc) {
        return Control_Monad_Except_Trans.runExceptT(bind(except(Data_Either.note(new $$Error.StringError("Position in fill queue out of bounds. Index: " + (show(state.position) + (" Queue: " + Steps_WorkQueue_State.showFillQueue(state.queue)))))(Steps_Step3_Types.currentFillEntry(state))))(function (entry) {
            if (entry.form instanceof Data_Either.Left) {
                return loadExistingFillState(state)(entry.form.value0)(state.workQueueState)(doc);
            };
            if (entry.form instanceof Data_Either.Right) {
                var docRef = {
                    formId: entry.form.value0,
                    studentId: entry.student,
                    documentId: Data_Maybe.Nothing.value
                };
                var v = Steps_WorkQueue_Cache.getDocByStudent(state.workQueueState)(docRef);
                if (v instanceof Data_Maybe.Just) {
                    return loadPreviousFillState(state)(v.value0)(entry.form.value0)(state.workQueueState);
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return createDocFormFillState(state)(entry.form.value0)(entry.student);
                };
                throw new Error("Failed pattern match at Steps.Step3.FillQueue (line 117, column 13 - line 119, column 77): " + [ v.constructor.name ]);
            };
            throw new Error("Failed pattern match at Steps.Step3.FillQueue (line 109, column 5 - line 119, column 77): " + [ entry.form.constructor.name ]);
        }));
    };
};
var loadInitFillQueue = function (workQueueState) {
    return function (workQueueUi) {
        return function (workQueueCache) {
            return function (doc) {
                return function (transitionState) {
                    return function (anchor) {
                        return Control_Monad_Except_Trans.runExceptT((function () {
                            var queue = Steps_WorkQueue_State.getFillQueue(workQueueState);
                            var position = initialQueuePosition(workQueueState)(queue);
                            return loadFillState({
                                queue: queue,
                                transitionState: transitionState,
                                workQueueState: workQueueState,
                                workQueueUi: workQueueUi,
                                workQueueCache: workQueueCache,
                                position: position,
                                anchor: anchor,
                                activeSection: anchor,
                                sectionIntent: Data_Maybe.maybe(App_Route.SectionClear.value)(App_Route.SectionSet.create)(anchor)
                            })(doc);
                        })());
                    };
                };
            };
        };
    };
};
var applySavedDocument = function (state) {
    return function (doc) {
        var workQueueState$prime = Steps_WorkQueue_Cache.insertDocument(doc)(state.workQueueState);
        var formCtx = Widgets_Form_Class.initFormContext(state.workQueueCache.account)(doc);
        var fillState = {
            attachments: state.fillState.attachments,
            comments: state.fillState.comments,
            doc: state.fillState.doc,
            preview: state.fillState.preview,
            signatures: state.fillState.signatures,
            form: {
                fields: state.fillState.form.fields,
                id: state.fillState.form.id,
                label: state.fillState.form.label,
                access: doc.access
            }
        };
        return bind1(finaliseFillState({
            queue: state.queue,
            position: state.position,
            anchor: state.anchor,
            activeSection: state.activeSection,
            sectionIntent: state.sectionIntent,
            transitionState: state.transitionState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            fillState: state.fillState,
            workQueueState: workQueueState$prime
        })(formCtx)(doc)(fillState))(function (nextState) {
            return pure1({
                activeSection: nextState.activeSection,
                anchor: nextState.anchor,
                position: nextState.position,
                queue: nextState.queue,
                sectionIntent: nextState.sectionIntent,
                transitionState: nextState.transitionState,
                workQueueCache: nextState.workQueueCache,
                workQueueState: nextState.workQueueState,
                workQueueUi: nextState.workQueueUi,
                fillState: {
                    attachments: nextState.fillState.attachments,
                    comments: nextState.fillState.comments,
                    doc: nextState.fillState.doc,
                    form: nextState.fillState.form,
                    preview: nextState.fillState.preview,
                    signatures: Widgets_Signature_Group.loadSignatures(nextState.fillState.doc)(state.fillState.signatures)
                }
            });
        });
    };
};
export {
    loadInitFillQueue,
    loadFillState,
    saveDocument,
    shouldSaveDocument,
    applySavedDocument,
    mergeTransitionWaitState
};
//# sourceMappingURL=index.js.map
